import Config from 'react-native-config';
import { Dispatch } from 'redux';
import {
  Action,
  ActionPayloadRequest,
  DispatcherAuthPrefix,
  DispatcherCategoryService,
  DispatcherResource
} from 'modules/types/common';
import { getDispatcherUrl } from 'modules/utils/UrlUtils';
import { DFDHeaders } from 'serverTypes/authentication';
import { Thunk } from 'store/types';
import { visitSummaryFullListRequestStateSelector } from './selectors';
import { VisitSummaryFilter, OptionType } from './types';
import { INIT_NUM_OF_VISITS_TO_FETCH } from './constants';
import * as actions from './actions.common';

export const setVisitSummaryFilter = (key: string, filter: Partial<VisitSummaryFilter>) => ({
  type: actions.SET_VISIT_SUMMARY_FILTER,
  payload: { [key]: filter }
});

export const setVisitSummarySortBy = (key: string, sortBy: OptionType) => ({
  type: actions.SET_VISIT_SUMMARY_SORT_BY,
  payload: { [key]: sortBy }
});

export const resetVisitSummaryFilter = () => ({
  type: actions.RESET_VISIT_SUMMARY_FILTER
});

export const getVisitSummaryFullList = (
  useCache = true,
  useRequestState = true,
  actionType = actions.GET_VISIT_SUMMARY_FULL_LIST,
  count: null | number = null
): Thunk => async (dispatch: Dispatch) => {
  const request: ActionPayloadRequest = {
    method: 'get',
    url: '/visit-summaries',
    params: {
      count
    }
  };
  let client = 'visitSummary';

  if (!!Config.VISIT_SUMMARY_EXPANSION_ENABLED) {
    request.url = getDispatcherUrl(
      DispatcherCategoryService.HEALTH_RECORDS,
      DispatcherAuthPrefix.AUTHENTICATED,
      DispatcherResource.VISIT_SUMMARIES
    );
    client = 'dispatcher';
    delete request.params;
  }
  if (!useCache) {
    request.headers = {
      [DFDHeaders.cacheControl]: 'no-cache',
      [DFDHeaders.mhpCacheControl]: 'no-cache'
    };
  }
  dispatch({
    type: actionType,
    payload: {
      useRequestState,
      requestStateSelector: visitSummaryFullListRequestStateSelector,
      cache: useCache,
      client,
      request
    }
  } as Action);

  dispatch(actions.getPollingStatusLooped(() => getVisitSummaryFullList(true, false)));
};

export const getVisitSummaryShortList = (useCache = true, count = INIT_NUM_OF_VISITS_TO_FETCH) =>
  getVisitSummaryFullList(useCache, true, actions.GET_VISIT_SUMMARY_SHORT_LIST, count);

export * from './actions.common';
